import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FeelSubscriptionState } from '@features/feel/domain/state/feel-subscription.state';

export const feelCommonState = createFeatureSelector<FeelSubscriptionState>('feel-common');

export const selectFeelSubscriptionError = createSelector(
    feelCommonState,
    (state: FeelSubscriptionState) => state?.status && state.status instanceof Error ? state.status : null
);

export const selectFeelSubscriptionLoading = createSelector(
    feelCommonState,
    (state: FeelSubscriptionState) => state?.status === 'loading'
);
